module.exports = __webpack_public_path__ + "assets/1fb8ee9034bfc054afa19cd8b3296563.mp3";